const TARGET_INSTITUTION = process.env.REACT_APP_TARGET_INSTITUTION ?? 'UES21';

export default {
  TARGET_INSTITUTION
};
